import type { CacheApi } from "../../api/CacheApi";
import type { CacheStatusStaff } from "../../generated/dto/CacheStatusStaff";
import type { DeleteCacheStatusStaff } from "../../generated/dto/DeleteCacheStatusStaff";

export class CacheFrontendService {
  constructor(private readonly api: CacheApi) {}
  async getCacheStatusStaff(id: number): Promise<CacheStatusStaff> {
    return this.api.getCacheStatusStaff(id)
  }
  async deleteCacheStatusStaff(source: DeleteCacheStatusStaff): Promise<void> {
    return this.api.deleteCacheStatusStaff(source)
  }
}
